<template>
  <div class="flex flex-wrap -mx-2 text-sm items-stretch">
    <div class="flex-1 w-full px-4">
      <h1 slot="header" class="w-full text-lg py-4">
        Meet the team pages
      </h1>
      <div class="flex flex-wrap -mx-2 text-xs mb-6 border-bottom border-b-2 border-light">
        <div class="w-full px-2 mt-2">
          <label for="offices" class="text-sm">Office:</label>
        </div>
        <div class="w-full lg:w-1/4 px-2 mb-4">
          <select id="offices" v-model="searchOffice" @change="getPagenatedUsers()" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm w-3/4">
            <option v-for="selecteOffice in office_list_team" :key="selecteOffice.id" :selected="selecteOffice.id" v-bind:value="{ id: selecteOffice.id, name: selecteOffice.name} ">{{selectedOfficeName = selecteOffice.name}}</option>
          </select>
        </div>
        <div v-if="isFineAndCountry" class="w-3/4 px-2 pt-4 h-full text-sm text-bottom">
          Select the office for which you would like to change the 'Meet the Team' page, then drag and drop the Staff Members below in to the order that you wish them to appear on the website. Top display first, bottom display last.
        </div>
        <div v-else class="w-3/4 px-2 pt-4 h-full text-sm text-bottom">
          Select the office for which you would like to change the 'Meet the Team' page, then drag and drop the Staff Members below in to the order that you wish them to appear. Top display first, bottom display last.
        </div>
      </div>
      <div class="flex flex-wrap -mx-2 text-sm mb-6 border-bottom border-b-2 border-light">
        <div class="w-full px-2 py-4">
          <span class="text-base font-bold mr-4">{{searchOffice.name}}</span>
          <span>{{users.length}}  Displayed Staff Members</span>
        </div>
      </div>
      <div v-if="!officeLoading" class="text-center text-xl">
        <p>Please select an office</p>
      </div>
      <loader v-else-if="loadingMeetTeam" class="mt-6" />
      <div class="w-full" v-else-if="users.length > 0">
        <table class="w-full">
          <thead>
          <tr class="text-sm align-top">
            <th class="py-5 uppercase">Order</th>
            <th class="py-5 uppercase"  @click="sortBy('name')">First Name
            </th>
            <th class="py-5 uppercase"  @click="sortBy('name')">Surname
            </th>
            <th class="py-5 uppercase" @click="sortBy('position')">Position
            </th>
            <th class="py-5 uppercase" @click="sortBy('key_info')">Key Contact Information
            </th>

            <th v-if="system.external_data.bios === true && system.external_data.reduced_bios === false && isFineAndCountry" class="py-5 uppercase">Website status</th>
            <th v-if="isFineAndCountry" class="py-5 uppercase">Edit</th>
            <th class="py-5 uppercase">Remove</th>
          </tr>
          </thead>

          <draggable v-model="users" tag="tbody" @change="updateOrder"  @end="onDragEnd" @start="onStart" @drag="dragg = true" :class="{dragg: 'grabbing'}" >
              <tr v-for="user in users" :key="user.id" class="border text-xs md:text-sm text-center" :class="{ 'bg-red-lightest':user.approved !==1 && system.external_data.bios === true && system.external_data.reduced_bios === false}">
                <td class="p-5 border-l-4"
                  :class="{
                  'border-green': user.associated_office.includes(searchOffice.id) === true && user.approved === 1 && system.external_data.bios === true && system.external_data.reduced_bios === false,
                  'border-grey': !user.associated_office.includes(searchOffice.id) === false && user.approved === 1 && system.external_data.bios === true && system.external_data.reduced_bios === false,
                  'border-red': user.approved !== 1 && system.external_data.bios === true && system.external_data.reduced_bios === false
                  }"
                  scope="row">{{(user.associated_office.length === 0 ? '-' : user.order )}}</td>
                <td class="p-5 font-bold">{{ user.first_name }}</td>
                <td class="p-5 font-bold">{{ user.surname }}</td>
                <td class="p-5">{{ user.position }}</td>
                <td class="p-5">
                  <div class="flex flex-col">
                     <div class="mb-1">{{ user.email }}</div>
                     <div>{{ user.phone}}</div>
                  </div>
                </td>
                <td v-if="system.external_data.bios === true && system.external_data.reduced_bios === false && isFineAndCountry" class="p-5">
                  <!-- <pop-over-profile :popUpUser='user'/> -->
                  <span class="block mt-1 text-green" v-if="user.approved === 1"><small>Approved</small></span>
                  <span class="block mt-1 text-red" v-else-if="!user.approved !== 1">
                    <small v-if="user.userApproval.status === 0">Waiting on Approval</small>
                    <small v-else-if="user.userApproval.status === 2">Profile Rejected</small>
                    <small v-else-if="user.userApproval.status === 3 || !user.userApproval.status">Not Yet Submitted</small>
                  </span>
                </td>
                <td>
                  <button class="h-8 w-8" @click="openUserAssociateModal(searchOffice.id,user.id)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </td>
                <td class="p-5 text-center border-r-4"
                  :class="{
                    'border-green': user.associated_office.includes(searchOffice.id) === true && user.approved === 1 && system.external_data.bios === true && system.external_data.reduced_bios === false,
                    'border-grey': !user.associated_office.includes(searchOffice.id) === false && user.approved === 1 && system.external_data.bios === true && system.external_data.reduced_bios === false,
                    'border-red': user.approved !== 1 && system.external_data.bios === true && system.external_data.reduced_bios === false
                  }"
                  title="display">
                  <!-- <div v-if="user.associated_office.includes(searchOffice.id)"> -->
                    <!-- <input type="checkbox"  :value="searchOffice.id" :id="user.name" v-bind:checked="user.associated_office.includes(searchOffice.id)" @click="addOfficeAssociation(searchOffice.id,user)">
                    <label :for="user.name"></label> -->
                  <!-- </div> -->
                  <button v-if="user.associated_office.includes(searchOffice.id)" class="h-8 w-8" @click="addOfficeAssociation(searchOffice.id,user)"><icon :center="false" name="close_small" class="h-8 w-8"></icon></button>
                  <button v-else @click="addOfficeAssociation(searchOffice.id,user)" class="h-8 w-8"><i class="fas fa-undo fa-2x h-8 w-8"></i></button>
                </td>
              </tr>
          </draggable>

        </table>
      </div>
      <div v-else class="text-center text-xl">
        <p>No Results</p>
      </div>
    </div>
     <deletion-modal
      v-if="deleteUserModal"
      @confirmed="deleteUser(deleteUserModal)"
      @leave="deleteUserModal = null"
      @dismissed="deleteUserModal = null">
      <p class="text-center"> User <strong>{{deleteUserModal.name}} </strong> is only associate to <strong>{{searchOffice.name}}</strong> if you remove this the user will be automatically deleted ?</p>
    </deletion-modal>
    <modal
      v-if="showUserAssociateModal"
      :scrollY="false"
      @leave="showUserAssociateModal = null"
      v-on:ChangeView="showUserAssociateModal = null"
      :showCloseBtn="true" width="180px"
    >
      <user-associate :selectedAssociateofficeId="selectedAssociateofficeId" :selectedAssociateuserId="selectedAssociateuserId" @close-user-associate-modal="closeUserAssociateModal" :selectedOfficeName="selectedOfficeName"></user-associate>
    </modal>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination'
import { mapState, mapActions } from 'vuex'
import api from '@/http'
import draggable from 'vuedraggable'
import _ from 'lodash'
import PopOverProfile from './PopOverProfile.vue'
import DeletionModal from '@/components/Modals/DeletionModal'
import UserAssociate from './UserAssociate.vue'

export default {
  name: 'ProfileTeam',
  components: {
    Pagination,
    draggable,
    PopOverProfile,
    DeletionModal,
    UserAssociate
  },
  data () {
    return {
      filters: {},
      loadingMeetTeam: true,
      users: [],
      sorting: {},
      searchOffice: '',
      office_list_team: [],
      selectedOfficeName: 'no office selected',
      deleteUserModal: null,
      dragg: false,
      officeLoading: null,
      showUserAssociateModal: false,
      selectedAssociateofficeId: null,
      selectedAssociateuserId: null
    }
  },
  computed: {
    ...mapState([ 'selectedOffice', 'system' ]),
    isFineAndCountry () {
      return this.system.networks[0].id === 7 || this.system.networks[0].id === 8
    }
  },
  methods:
  {
    ...mapActions([
      'displayToastNotification'
    ]),
    deleteUser (user) {
      api
        .delete(`deleted-user/${user.id}`)
        .then(response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User deleted ',
            info: 'Your user has been deleted successfully.'
          })
          this.getPagenatedUsers()
          this.deleteUserModal = false
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User deleting',
            info: 'Error deleting User.'
          })
        })
    },
    getPagenatedUsers () {
      this.loadingMeetTeam = true
      let params = {
        office_id: this.searchOffice.id
      }
      api.get('/list-meet-team', { params }).then(response => {
        var users = response.data
        this.users = users.map((user, index) => {
          user.order = index + 1
          return user
        })
        this.loadingMeetTeam = false
        this.officeLoading = true
      }).catch(({ response }) => {
        //
      })
    },
    getOfficeList () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/office-list', { params }).then(response => {
        this.office_list_team = response.data
        this.searchOffice = {
          id: response.data[0].id,
          name: response.data[0].name
        }
        this.getPagenatedUsers()
      }).catch(({ response }) => {
        if (response.status === 422) {
        }
      })
    },
    addOfficeAssociation (officeId, user) {
      if (user.associated_office.length === 1 && user.associated_office.includes(officeId) && user.type === 8) {
        this.deleteUserModal = user
        return
      }
      if (user.associated_office.includes(officeId)) {
        user.associated_office = _.without(user.associated_office, officeId)
      } else {
        user.associated_office.push(officeId)
      }
      console.log(user.associated_office)
      this.saveUser(user)
    },
    async saveUser (val) {
      val['office_id'] = this.selectedOffice.id
      api.patch('/update-user/' + val.id, val).then(
        response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User Updated',
            info: 'Your user has been updated successfully.'
          })
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User',
            info: 'Error saving user.'
          })
        }
      )
    },
    onDragEnd: function (e) {
      const className = 'grabbing'
      const html = document.getElementsByTagName('html').item(0)
      if (html && new RegExp(className).test(html.className) === true) {
        // Remove className with the added space (from setClassToHTMLElement)
        html.className = html.className.replace(
          new RegExp(' ' + className),
          ''
        )
        // Remove className without added space (just in case)
        html.className = html.className.replace(new RegExp(className), '')
      }
    },
    onStart: function () {
      const className = 'grabbing'
      const html = document.getElementsByTagName('html').item(0)
      if (html && new RegExp(className).test(html.className) === false) {
        html.className += ' ' + className // use a space in case there are other classNames
      }
    },
    updateOrder () {
      this.users.map((user, index) => {
        user.order = index + 1
      })
      var dataToSend = {
        office_id: this.searchOffice.id,
        users: this.users
      }
      console.log(dataToSend)
      api.patch('/update-order', dataToSend).then(
        response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Order Updated',
            info: 'Your order has been updated successfully.'
          })
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Order',
            info: 'Error saving Order.'
          })
        }
      )
    },
    openUserAssociateModal (officeId, userId) {
      this.selectedAssociateofficeId = officeId
      this.selectedAssociateuserId = userId
      this.showUserAssociateModal = true
    },
    closeUserAssociateModal () {
      this.showUserAssociateModal = false
    }
  },
  created () {
    this.getOfficeList()
  },
  watch: {
    selectedOffice: function (val, prev) {
      if (val.id !== prev.id) {
        this.getOfficeList()
      }
    }
  }
}
</script>

<style scoped>
.grabbing * {
    cursor: grabbing !important;
}
</style>
